import { Component, EventEmitter, NgZone, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';

import { AuthApiService } from '../api/auth-api.service';

const DEBUG = false;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {

  @Output() status = new EventEmitter<boolean>();
  signedIn = false;
  signedOut = true;
  subscription: Subscription|undefined;

  constructor(public authService: AuthApiService, private ngZone: NgZone) {
    if (DEBUG) {console.log('new LoginComponent()');}
  }

  ngOnInit(): void {
    this.subscription = this.authService.signedIn$.subscribe(value => {
      this.signedIn = value;
      this.signedOut = !value;
      this.status.emit(value);
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  signIn(): void {
    if (DEBUG) {console.log('LoginComponent signIn()');}
    this.authService.signIn();
  }

  signOut(): void {
    if (DEBUG) {console.log('LoginComponent signOut()');}
    this.authService.signOut();
  }

}
